import { alpha, Chip, Stack } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import type { GridRowSelectionModel } from '@mui/x-data-grid'
import React from 'react'
import { useTranslation } from 'react-i18next'

import CustomTypography from '@/components/dataDisplay/CustomTypography'
import type { Site } from '@/features/site/types/site'

interface SelectedCustomersProps {
  sites: Site[]
  selection: GridRowSelectionModel
  onRemove: any
}

export function SelectedSites({ sites, selection, onRemove }: Readonly<SelectedCustomersProps>) {
  const theme = useTheme()
  const { t } = useTranslation()
  const selectedVisibleSites = sites.filter((customer) => {
    return Array.from(selection.ids).includes(customer.uuid)
  })
  const backgroundColor = selectedVisibleSites.length > 0 ? theme.palette.primary.main : theme.palette.common.black
  return (
    <Stack
      mb={2}
      p={2}
      sx={{
        backgroundColor: alpha(backgroundColor, 0.08),
      }}
    >
      {selection.ids.size > 0 ? (
        <div>
          <CustomTypography gutterBottom variant="body1">
            {t('user_form.form.customer_access_selected_customers')}
          </CustomTypography>
          <Stack useFlexGap direction="row" flexWrap="wrap" mt={2} spacing={1}>
            {selectedVisibleSites.map((site) => (
              <Chip key={site?.uuid} label={site?.name} onDelete={() => onRemove(site?.uuid)} />
            ))}
          </Stack>
        </div>
      ) : (
        <div>
          <CustomTypography gutterBottom variant="body1">
            {t('user_form.form.customer_access_nothing_selected')}
          </CustomTypography>
        </div>
      )}
    </Stack>
  )
}
